import React from "react"

import { ProductPositionInstallationReferences } from "./ProductPositionInstallationReferences"

export const ProductPositionFormInstallationReferencesTab = React.memo(() => (
  <div className="product-position-form__tab-content">
    <ProductPositionInstallationReferences />
  </div>
))
